var _path, _path2, _path3, _path4, _path5, _path6, _mask, _path7, _mask2, _path8, _mask3, _path9, _mask4, _path10, _mask5, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8209 11.8227H18.4843C18.6713 11.8227 18.8272 11.9785 18.796 12.1656L18.2349 16.0935C18.1725 16.4365 17.9231 16.6547 17.6114 16.6547H6.38861C6.07687 16.6547 5.82748 16.4365 5.76513 16.1247L5.20399 12.1656C5.17281 11.9785 5.32869 11.8227 5.51573 11.8227H13.61",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4555 16.6547V18.2446",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57567 16.6547V18.2446",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 11.1992H14.5587C14.0064 11.1992 13.5587 11.647 13.5587 12.1992V12.6932C13.5587 13.2455 14.0064 13.6932 14.5587 13.6932H15.8008C16.3531 13.6932 16.8008 13.2455 16.8008 12.6932V12.1992C16.8008 11.647 16.3531 11.1992 15.8008 11.1992Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57079 7.3647C8.57079 6.61651 7.97848 6.0242 7.2303 6.0242C6.48211 6.0242 5.8898 6.61651 5.8898 7.3647V11.8226",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76033 7.4583H9.41257",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_4218_34091",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29014 8.36229H7.729V8.92343H8.29014V8.36229Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.729 8.36229V7.36229H6.729V8.36229H7.729ZM8.29014 8.36229H9.29014V7.36229H8.29014V8.36229ZM8.29014 8.92343V9.92343H9.29014V8.92343H8.29014ZM7.729 8.92343H6.729V9.92343H7.729V8.92343ZM7.729 9.36229H8.29014V7.36229H7.729V9.36229ZM7.29014 8.36229V8.92343H9.29014V8.36229H7.29014ZM8.29014 7.92343H7.729V9.92343H8.29014V7.92343ZM8.729 8.92343V8.36229H6.729V8.92343H8.729Z",
    fill: "var(--icon-color,var(--color-text,#363636))",
    mask: "url(#path-7-inside-1_4218_34091)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-2_4218_34091",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.44368 8.36229H8.88254V8.92343H9.44368V8.36229Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88254 8.36229V7.36229H7.88254V8.36229H8.88254ZM9.44368 8.36229H10.4437V7.36229H9.44368V8.36229ZM9.44368 8.92343V9.92343H10.4437V8.92343H9.44368ZM8.88254 8.92343H7.88254V9.92343H8.88254V8.92343ZM8.88254 9.36229H9.44368V7.36229H8.88254V9.36229ZM8.44368 8.36229V8.92343H10.4437V8.36229H8.44368ZM9.44368 7.92343H8.88254V9.92343H9.44368V7.92343ZM9.88254 8.92343V8.36229H7.88254V8.92343H9.88254Z",
    fill: "var(--icon-color,var(--color-text,#363636))",
    mask: "url(#path-9-inside-2_4218_34091)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_4218_34091",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85139 9.48459H8.29025V10.0457H8.85139V9.48459Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29025 9.48459V8.48459H7.29025V9.48459H8.29025ZM8.85139 9.48459H9.85139V8.48459H8.85139V9.48459ZM8.85139 10.0457V11.0457H9.85139V10.0457H8.85139ZM8.29025 10.0457H7.29025V11.0457H8.29025V10.0457ZM8.29025 10.4846H8.85139V8.48459H8.29025V10.4846ZM7.85139 9.48459V10.0457H9.85139V9.48459H7.85139ZM8.85139 9.04573H8.29025V11.0457H8.85139V9.04573ZM9.29025 10.0457V9.48459H7.29025V10.0457H9.29025Z",
    fill: "var(--icon-color,var(--color-text,#363636))",
    mask: "url(#path-11-inside-3_4218_34091)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-4_4218_34091",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43956 10.0562H10.0007V9.49503H9.43956V10.0562Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.0562V11.0562H11.0007V10.0562H10.0007ZM9.43956 10.0562H8.43956V11.0562H9.43956V10.0562ZM9.43956 9.49503V8.49503H8.43956V9.49503H9.43956ZM10.0007 9.49503H11.0007V8.49503H10.0007V9.49503ZM10.0007 9.05617H9.43956V11.0562H10.0007V9.05617ZM10.4396 10.0562V9.49503H8.43956V10.0562H10.4396ZM9.43956 10.495H10.0007V8.49503H9.43956V10.495ZM9.0007 9.49503V10.0562H11.0007V9.49503H9.0007Z",
    fill: "var(--icon-color,var(--color-text,#363636))",
    mask: "url(#path-13-inside-4_4218_34091)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-5_4218_34091",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16768 10.0562H7.72882V9.49503H7.16768V10.0562Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72882 10.0562V11.0562H8.72882V10.0562H7.72882ZM7.16768 10.0562H6.16768V11.0562H7.16768V10.0562ZM7.16768 9.49503V8.49503H6.16768V9.49503H7.16768ZM7.72882 9.49503H8.72882V8.49503H7.72882V9.49503ZM7.72882 9.05617H7.16768V11.0562H7.72882V9.05617ZM8.16768 10.0562V9.49503H6.16768V10.0562H8.16768ZM7.16768 10.495H7.72882V8.49503H7.16768V10.495ZM6.72882 9.49503V10.0562H8.72882V9.49503H6.72882Z",
    fill: "var(--icon-color,var(--color-text,#363636))",
    mask: "url(#path-15-inside-5_4218_34091)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.34ccc3b6980d93d3d4e8181c502a5f0a.svg";
export { ForwardRef as ReactComponent };